import {
  assign, endpoint, options, check, convert,
} from '../helpers';
import { Report as action } from '../../redux/actions';

/**
 * Fetches all report information for the user
 *
 * @function
 * @param {Object} properties All parameters to be used in the function
 */

const reports = (properties) => {
  const props = assign(properties);
  const model = {
    Token: window.parseInt(props.data.token),
  };

  fetch(endpoint('/report-list'), options(model))
    .then(response => response.json())
    .then((response) => {
      check(response.Token);
      if (response.Success) {
        if (props.dispatch) {
          props.dispatch(action.override(response.Data));
        }
        props.success(response.Data);
      } else {
        props.error(convert(response.Message));
      }
    })
    .catch(output => window.console.warn(output));
};

export default reports;
